{
  "w": 28,
  "h": 18,
  "rows": [
    "............................",
    "....WWWWWWWWWWWWWWWWWWWW....",
    "..MMCCCCCCCCCCCCCCCCCCCCMM..",
    "MMCCCCCCCCCCCCCCCCCCCCCCCCMM",
    "MMCCCCCCCCCCCCCCCCCCCCCCCCMM",
    "MMccccccccccccccccccccccccMM",
    "MKKKKKKKKKKKKKKKKKKKKKKKKKKM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "RRKmmmmmmmmmmmmmmmmmmmmmmKRR",
    "RRKmmmmmmmmmmmmmmmmmmmmmmKRR",
    "RRKmmmmmmmmmWWWWmmmmmmmmmKRR",
    "KKWKKKKKKKKKKKKKKKKKKKKKKWKK",
    "......KKKK........KKKK......",
    "............................"
  ],
  "legend": {
    "K": "C.BLACK",
    "M": "C.B_MAGENTA",
    "m": "C.MAGENTA",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "R": "C.RED"
  }
}
